import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-view" }
const _hoisted_2 = {
  key: 0,
  class: "initialization-loader-container"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainViewToolbar = _resolveComponent("MainViewToolbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_NoteTabs = _resolveComponent("NoteTabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MainViewToolbar, {
      status: _ctx.channelStatus,
      msgStatus: _ctx.msgStatus
    }, null, 8, ["status", "msgStatus"]),
    (_ctx.firstInitialization)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_ProgressSpinner, {
            strokeWidth: "3",
            style: {"width":"150px","height":"150px"}
          })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_NoteTabs, {
            key: _ctx.lastNoteFeedUpdate,
            notes: _ctx.notes,
            onNoteChanged: _ctx.onNoteChanged,
            onNewNote: _ctx.onNewNote
          }, null, 8, ["notes", "onNoteChanged", "onNewNote"])
        ]))
  ]))
}